import './gridSearchInput.less'

import React from "react"
import {observer} from "mobx-react"
import classNames from "classnames"

import {GridStore} from "controls/grid/gridStore"
import {AntInput} from "controls/react/ant/antInput"
import {linkModel} from "framework/mobx-integration"
import {GridDataEntry} from "controls/grid/gridDataEntry"
import {getStore, GridStoreHolder} from "controls/grid/utils/getStore";

const b = require('b_').with('grid-search-input')

const i = require('core/localization/localization').translator();

type GridSearchInputProps<T extends GridDataEntry> = {
	store: GridStoreHolder<T>
}

export const GridSearchInput = observer(<T extends GridDataEntry, >(props: GridSearchInputProps<T>) => {
	const store = getStore(props.store)

	if (!store?.selfInitialized)
		return null

	const classes = classNames(
		b({'active': !!store.state.searchString}),
		'_bypass-dirty-check'
	)

	return <AntInput placeholder={i('Search...')}
	                 size={"small"}
	                 bounced={1000}
	                 className={classes}
	                 {...linkModel(store.state, "searchString")}
	/>
})
